export default __webpack_public_path__ + "static/media/apple-touch-icon.c8a8a81c.png";